export default "__VITE_ASSET__5FYukV2H__"